import { MIDIValInput } from '@midival/core'
import { 
  actionTypes, 
  FetchClientDataRequestPayload,
  FetchClientDataSuccessPayload, 
  FetchClientDataErrorPayload,
  setLessonPlayingPayload,
  SetLevelSelectPayload,
  SetUnitSelectPayload,
  SetTempoPayload,
  FetchTutorialDataPayload,
  FetchTutorialDataSuccessPayload,
  UserLevelDataSuccessPayload,
  AuthenticationToken,
  SetHighestLevelCompletedPayload,
  LevelDataSuccessPayload,
  UpdateCurrentULPPayload,
  UserLevelData,
  TiersByLevels,
  IUserData,
  IUpdateUserData,
  UserInfo,
  AppState,
 } from '../Types'

export const fetchClientDataRequest = (payload: FetchClientDataRequestPayload) => ({
  type: actionTypes.FETCH_CLIENT_DATA_REQUEST,
  payload
})
export const fetchClientDataSuccess = (payload: FetchClientDataSuccessPayload) => ({
  type: actionTypes.FETCH_CLIENT_DATA_SUCCESS,
  payload
})
export const fetchClientDataError = (payload: FetchClientDataErrorPayload) => ({
  type: actionTypes.FETCH_CLIENT_DATA_ERROR,
  payload
})
export const setLessonPlaying = (payload: setLessonPlayingPayload) => ({
  type: actionTypes.SET_LESSON_PLAYING,
  payload
})
export const setLevelSelect = (payload: SetLevelSelectPayload) => ({
  type: actionTypes.SET_LEVEL_SELECT,
  payload
})
export const setUnitSelect = (payload: SetUnitSelectPayload) => ({
  type: actionTypes.SET_UNIT_SELECT,
  payload
})
export const setTempo = (payload: SetTempoPayload) => ({
  type: actionTypes.SET_TEMPO,
  payload
})

export const setHighestLevelCompleted = (payload: SetHighestLevelCompletedPayload) => ({
  type: actionTypes.SET_HIGHEST_LEVEL_COMPLETED,
  payload
})

export const fetchTutorialData = (payload: AuthenticationToken) => ({
  type: actionTypes.FETCH_TUTORIAL_DATA,
  payload
})

export const fetchTutorialDataProcessing = (payload: boolean) => ({
  type: actionTypes.FETCH_TUTORIAL_DATA_PROCESSING,
  payload
})

export const fetchTutorialDataSuccess = (payload: FetchTutorialDataSuccessPayload) => ({
  type: actionTypes.FETCH_TUTORIAL_DATA_SUCCESS,
  payload
})

export const midiInputSetUp = (payload: MIDIValInput) => ({
  type: actionTypes.MIDI_INPUT_SETUP,
  payload
})

export const authenticatedStartup = (payload: AuthenticationToken & UserInfo) => ({
  type: actionTypes.AUTHENTICATED_STARTUP,
  payload
})

export const fetchUserLevelsSuccess = (payload: UserLevelDataSuccessPayload) => ({
  type: actionTypes.FETCH_USER_LEVEL_SUCCESS,
  payload
})

export const fetchLevelDataSuccess = (payload: LevelDataSuccessPayload) => ({
  type: actionTypes.FETCH_LEVEL_DATA_SUCCESS,
  payload
})

export const updateCurrentULP = (payload: UpdateCurrentULPPayload & UserInfo) => ({
  type: actionTypes.UPDATE_CURRENT_ULP,
  payload
})

export const updateCurrentULPSuccess = (payload: UserLevelData) => ({
  type: actionTypes.UPDATE_CURRENT_ULP_SUCCESS,
  payload
})

export const updatePhrasesTilNextTier = (payload: number) => ({
  type: actionTypes.UPDATE_PHRASES_TIL_NEXT_TIER,
  payload
})

export const updateCurrentLevelTiers = (payload: number) => ({
  type: actionTypes.UPDATE_CURRENT_LEVEL_TIERS,
  payload
})

export const updateTiersByLevels = (payload: TiersByLevels[]) => ({
  type: actionTypes.UPDATE_TIERS_BY_LEVELS,
  payload
})

export const setLastShowSurvey = (payload: {
  last_shown_survey: Date
} & AuthenticationToken) => ({
  type: actionTypes.SET_LAST_SHOWN_SURVEY,
  payload
})

export const setShownIntroduction = (payload: boolean) => ({
  type: actionTypes.SET_SHOWN_INTRODUCTION,
  payload
})

export const setUserData = (payload: Partial<IUserData>) => ({
  type: actionTypes.SET_USER_DATA,
  payload
})

export const updateUserData = (payload: IUpdateUserData) => ({
  type: actionTypes.UPDATE_USER_DATA,
  payload
})

export const resetLesson = () => ({
  type: actionTypes.RESET_LESSON,
  payload: null
})

export const SetAudioOn = (payload: {
  audioOn: boolean
} & AuthenticationToken) => ({
  type: actionTypes.SET_AUDIO_ON,
  payload: payload
})

export const SetRepMetronomeSound = (payload: {
  repMetronomeSound: boolean
} & AuthenticationToken) => ({
  type: actionTypes.SET_REP_METRONOME_SOUND,
  payload: payload
})

export const SetRepDownbeatsSound = (payload: {
  repDownbeatsSound: boolean
} & AuthenticationToken) => ({
  type: actionTypes.SET_REP_DOWNBEATS_SOUND,
  payload: payload
})

export const loadUserState = (payload: AppState) => ({
  type: actionTypes.LOAD_USER_STATE,
  payload
})

export const updateMailchimpData = (payload: any) => ({
  type: actionTypes.UPDATE_MAILCHIMP_INFO,
  payload
})

export const setFullScreen = (payload: boolean) => ({
  type: actionTypes.SET_FULL_SCREEN,
  payload
})

export const getSubscriptionStatus = (payload: AuthenticationToken) => ({
  type: actionTypes.GET_SUBSCRIPTION_STATUS,
  payload
})

export const setSubscriptionStatus = (payload: string) => ({
  type: actionTypes.SET_SUBSCRIPTION_STATUS,
  payload
})

export const setPlaySessionId = (payload: string) => ({
  type: actionTypes.SET_PLAY_SESSION_ID,
  payload
})